// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "heic2any" + "." + "2cb02fec" + ".chunk.js";
};